import React from 'react';
import { Link } from 'react-router-dom';
import { BrandMark } from './BrandMark';
type LogoProps = {
  tone?: 'dark' | 'light';
};
export function Logo({
  tone = 'dark'
}: LogoProps) {
  const text = tone === 'dark' ? 'text-navy' : 'text-white';
  const sub = tone === 'dark' ? 'text-ink/70' : 'text-white/70';
  return <Link to="/" className={`flex items-center gap-3 rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold ${text}`} aria-label="Rising Talent Partners — home" data-id="element-221" data-mp="3v9fu98wha4al">
      <BrandMark size={34} data-id="element-222" data-mp="rr60yjgtofxm" />
      <span className="flex flex-col leading-none" data-id="element-223" data-mp="ds6cbbtb811g">
        <span className="font-serif text-[23px] font-semibold tracking-tight" data-id="element-224" data-mp="dreh423mk5bp">Rising Talent</span>
        <span className="mt-1 flex items-center gap-2" data-id="element-225" data-mp="hsggqk1geje7">
          <span className="h-px w-4 bg-gold" aria-hidden="true" data-id="element-226" data-mp="2yin9vz2ihq30" />
          <span className={`text-[10px] font-semibold uppercase tracking-[0.34em] ${sub}`} data-id="element-227" data-mp="2yh3wcg88pt4x">
            Partners
          </span>
        </span>
      </span>
    </Link>;
}